<template>
  <div class="staff">
    <div class="staff-modal" v-if="activeModal">
      <div class="close-icon" @click.prevent="activeModal = false"></div>
      <div class="overlay" @click.prevent="activeModal = false"></div>
      <div class="modal-card">
        <div class="row" style="height: inherit;">
          <div class="col-12 card-img" :style="{backgroundImage: `url('/${$staticPath}/${selectedProfile.profile}')`}" ></div>
          <div class="col-12 card-text">
            <div class="info">
              <span><b>{{ modal.name }} : </b></span>
              <span>{{ selectedProfile.name }}</span>
            </div>
            <div class="info">
              <span class="head" :class="{'more-position': selectedProfile.position.length > 1}">
                <b>{{ modal.position }} : </b>
              </span>
              <div class="position-block">
                <template v-for="(item, index) in selectedProfile.position">
                  <span :key="'span' + index"><span v-if="selectedProfile.position.length !== 1">- </span>{{ selectedProfile.position[index] }}</span>
                  <br :key="'br' + index" v-if="index !== selectedProfile.position.length - 1" />
                </template>
              </div>
            </div>
            <div class="info" v-if="selectedProfile.hasOwnProperty('email')">
              <span>
                <b>{{ modal.mail }} : </b>
              </span>
              <span>{{ selectedProfile.email }}</span>
            </div>
            <div class="info">
              <span>
                <b>{{ modal.educate }} :</b>
              </span>
              <div class="educate-info">
                <p
                  v-for="(edu, index) in selectedProfile.education"
                  :key="index"
                  v-html="edu"
                ></p>
              </div>
            </div>
            <div class="info" v-if="selectedProfile.hasOwnProperty('research')">
              <span>
                <b>{{ modal.research }} :</b>
              </span>
              <div class="educate-info">
                <p
                  v-for="(edu, index) in selectedProfile.research"
                  :key="index"
                  v-html="edu"
                ></p>
              </div>
            </div>
            <div class="info" v-if="selectedProfile.hasOwnProperty('interesting')">
              <span>
                <b>{{ modal.interested }} :</b>
              </span>
              <div class="educate-info">
                <p
                  v-for="(edu, index) in selectedProfile.interesting"
                  :key="index"
                  v-html="edu"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <template v-if="isLoaded">
        <Header :headerText="index.headerText"></Header>
        <div class="content">
          <StaffCarousel :classesProp="carousel.classes" @selectClass="selectClass"></StaffCarousel>
          <StaffInfo :staff="staff" @selectProfile="selectProfile"></StaffInfo>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Header from '../COMMON/Header'
import StaffCarousel from './Carousel'
import StaffInfo from './StaffInfo'

export default {
  components: {
    Header,
    StaffCarousel,
    StaffInfo
  },
  data () {
    return {
      index: {},
      carousel: {},
      modal: {},
      staff: {},
      isLoaded: false,
      selectedProfile: {},
      activeModal: false
    }
  },
  created () {
    this.init()
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.activeModal) {
        this.activeModal = !this.activeModal
      }
    })
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var index = await import('../../json/en/staff/staff.json')
        var carousel = await import('../../json/en/staff/carousel.json')
        var modal = await import('../../json/en/staff/modal.json')
        this.staff = await import(`../../json/en/staff/directors.json`)
      } else {
        index = await import('../../json/th/staff/staff.json')
        carousel = await import('../../json/th/staff/carousel.json')
        modal = await import('../../json/th/staff/modal.json')
        this.staff = await import(`../../json/th/staff/directors.json`)
      }
      this.index = index
      this.carousel = carousel
      this.modal = modal
      this.isLoaded = true
    },
    selectClass: async function (path) {
      if (this.$route.params.lang === 'en') {
        this.staff = await import(`../../json/en/staff/${path}.json`)
      } else {
        this.staff = await import(`../../json/th/staff/${path}.json`)
      }
    },
    selectProfile: function (profile) {
      this.selectedProfile = profile
      this.activeModal = true
    }
  },
  watch: {
    activeModal: function () {
      document.body.style.overflow = this.activeModal ? 'hidden' : ''
    }
  }
}
</script>

<style scoped>
  @import url('../../../static/css/staff-style/staff.css');
</style>



// WEBPACK FOOTER //
// src/components/STAFF/Staff.vue